import type { ListItem } from '@/components/Accordion';
import { useTranslation } from '@/utils/useTranslation';
import HelpPageLayout from '@/components/HelpPageLayout';
import { useGlobalContext } from '../GlobalProvider';

const COOKIES_LIST = [
  'NEXT_LOCALE',
  'OptanonAlertBoxClosed',
  'OptanonConsent',
  '_ga',
  '_ga_xxxxxxxxxx',
  '_hjSessionUser_xxxxxxx',
  '_hjSession_xxxxxxx',
  'ak_bmsc',
  'bm_sv',
  'gtm_data',
  'appSession.0',
  'appSession.1',
];

const Cookies = () => {
  const { programmeId = 'BAEC' } = useGlobalContext();

  const { t } = useTranslation(`${programmeId}/cookies`);

  const cookies = t<Array<ListItem>>('cookies', {
    returnObjects: true,
  });

  return (
    <HelpPageLayout
      title={t('title')}
      description={t('description')}
      list={cookies}
      cookies={COOKIES_LIST}
    />
  );
};

export default Cookies;
